/**
 * Generate Page
 * Statement generation interface
 */

import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { GeneratorForm } from '../components/Generator/GeneratorForm';
import { StatementResults } from '../components/Generator/StatementResults';

export const Generate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [result, setResult] = useState<any | null>(null);

  // Get template ID from URL query parameter
  const initialTemplateId = searchParams.get('templateId') || undefined;

  const handleReset = () => {
    setResult(null);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      {!result && (
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Generate Statement
          </h1>
          <p className="text-gray-600">
            Create realistic mock bank statements for testing and development purposes.
            All generated data is fictional and includes a SAMPLE watermark.
          </p>
        </div>
      )}

      {/* Content */}
      {!result ? (
        <GeneratorForm
          onGenerationSuccess={setResult}
          initialTemplateId={initialTemplateId}
        />
      ) : (
        <StatementResults result={result} onReset={handleReset} />
      )}
    </div>
  );
};
